module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ir71J"))).then(() => parcelRequire('5erN3'));